import * as angular from 'angular';

"use strict";
angular.module('ExceptionsModule', []);

export default 'ExceptionsModule';
